<highcharts-chart
  *ngIf="chartOptions"
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [callbackFunction]="getCallbackWithContext()"
  [style]="{'height': height}"
  class="block">
</highcharts-chart>
